export const APPOINTMENT_SCHEDULE_REQUEST = 'APPOINTMENT_SCHEDULE_REQUEST';
export const APPOINTMENT_SCHEDULE_RECEIVE = 'APPOINTMENT_SCHEDULE_RECEIVE';
export const APPOINTMENT_SCHEDULE_FAILURE = 'APPOINTMENT_SCHEDULE_FAILURE';

export const SELECT_APPOINTMENT_SCHEDULE = 'SELECT_APPOINTMENT_SCHEDULE';
export const SELECT_SERVICE = 'SELECT_SERVICE';
export const SELECT_CABINET = 'SELECT_CABINET';
export const SELECT_GENDER = 'SELECT_GENDER';

export const RESET_SCHEDULE = 'RESET_SCHEDULE';



// WEBPACK FOOTER //
// frontend/src/modules/mobile/constants/schedule.js